module.exports = __webpack_public_path__ + "img/percentage.3004020c.svg";